export enum InventoryManagerStatuses {
  Active = "Active",
  Inactive = "Inactive "
}

export const INVENTORY_MANAGER_STATUSES_LIST = [
  {
    label: "Active",
    value: InventoryManagerStatuses.Active,
    backgroundColor: "#16C350"
  },
  {
    label: "Inactive",
    value: InventoryManagerStatuses.Inactive,
    backgroundColor: "#A8A8BB"
  }
];
